import {Comment} from "../objects/Comment";
import {Post} from "../objects/Post";
import {ActivityType, WithDefaultActions} from "../../store/parsers/types";
import {PostLikes} from "./activities/GetLikes";
import {PostComments} from "./GetComments";
import {PostCommentsLikes} from "./activities/GetCommentsLikes";
import GetActivities from "./GetActivities";

export interface GetActivitiesItemsParams extends WithDefaultActions {
    posts: Post[],
    activity_types: Set<ActivityType>,
    comments_preview_length: number,
    access_token: string,
}

export interface PostActivitiesItems {
    post: Post,
    likes: number[],
    reposts: number[],
    comments: Comment[],
    comments_likes: PostCommentsLikes[],
}

const GetActivitiesItems = function* (params: GetActivitiesItemsParams): Generator<any, Map<number, PostActivitiesItems>, any> {

    const activities_map: Map<number, PostActivitiesItems> = new Map<number, PostActivitiesItems>();
    params.posts.forEach((post: Post) => {
        activities_map.set(post.id, {
            post: post,
            likes: [],
            reposts: [],
            comments: [],
            comments_likes: [],
        });
    });

    const likes_handler = (likes: PostLikes[]) => {
        likes.forEach((item: PostLikes) => {
            let activities: PostActivitiesItems|undefined = activities_map.get(item.post_id);
            if (activities) {
                activities.likes = item.likes;
                activities_map.set(item.post_id, activities);
            }
        });
    };

    const reposts_handler = (likes: PostLikes[]) => {
        likes.forEach((item: PostLikes) => {
            let activities: PostActivitiesItems|undefined = activities_map.get(item.post_id);
            if (activities) {
                activities.reposts = item.likes;
                activities_map.set(item.post_id, activities);
            }
        });
    };

    const comments_handler = (comments: PostComments[]) => {
        comments.forEach((item: PostComments) => {
            let activities: PostActivitiesItems|undefined = activities_map.get(item.post_id);
            if (activities) {
                activities.comments = item.comments;
                activities_map.set(item.post_id, activities);
            }
        });
    };

    const comments_likes_handler = (comments_likes: PostCommentsLikes[]) => {
        comments_likes.forEach((item: PostCommentsLikes) => {
            let activities: PostActivitiesItems|undefined = activities_map.get(item.post_id);
            if (activities) {
                activities.comments_likes.push(item);
                activities_map.set(item.post_id, activities);
            }
        });
    };

    yield GetActivities({
        posts: params.posts,
        activity_types: params.activity_types,
        comments_preview_length: params.comments_preview_length,
        access_token: params.access_token,
        progress_action: params.progress_action,
        add_api_errors_action: params.add_api_errors_action,

        likes_handler: likes_handler,
        reposts_handler: reposts_handler,
        comments_handler: comments_handler,
        comments_likes_handler: comments_likes_handler,
    });

    return activities_map;

};

export default GetActivitiesItems;
